import React from 'react';
import Legal from '../Legal';
import InfoModalTxt from '../modal_txt/InfoModalTxt';


export default function DisclamerModal(props, { handler }) {
    const [showModal, setShowModal] = React.useState(false);
    return (
        <>
            {props.title !== undefined &&

                <span onClick={() => setShowModal(true)}>
                    <button style={{ backgroundColor: props.color }} className={`text-white mt-6 inline-block w-1/2 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none`}>
                        Get Started!
                    </button>
                </span>
            }
            {showModal ? (
                <div>
                    <div className="z-50 fixed top-0 left-0 flex items-center justify-center w-full h-full outline-none overflow-x-hidden overflow-y-auto"
                        id="exampleModalScrollable" tabIndex="-1" aria-labelledby="exampleModalScrollableLabel" aria-hidden="true">
                        <div className="max-w-lg my-6 mx-auto w-auto pointer-events-none">
                            <div className="max-h-full overflow-hidden border-none shadow-lg flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                                {/*content*/}
                                <div className="flex-auto overflow-y-auto text-black relative p-4">
                                    <InfoModalTxt title={props.title} desc={props.desc} />
                                </div>
                                <div className="relative p-6 flex-auto">
                                    <div className="flex flex-wrap -mx-3">
                                        <div className="w-full md:w-1/2 px-3 md:mb-0 mb-4">
                                            <button
                                                style={{ backgroundColor: props.color }}
                                                className={`w-full text-white focus:ring-4 focus:outline-none focus:ring-${props.partner}-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center`}
                                                type="button"
                                                onClick={() => setShowModal(false)}
                                            >
                                                Close
                                            </button>
                                        </div>
                                        <div className="w-full md:w-1/2 px-3 md:mb-0 mb-4">
                                            <button
                                                style={{ backgroundColor: props.color }}
                                                className={`w-full text-white focus:ring-4 focus:outline-none focus:ring-${props.partner}-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center`}
                                                type="button"
                                                onClick={() => props.nextStep()}

                                            >
                                                Continue
                                            </button>
                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-60 fixed inset-0 z-40 bg-black flex-1"></div>
                </div>
            ) : null}
        </>
    );
}